import type { ActivityReservation } from "@b2bportal/rbc-activities-api";
import { DateTimeFormatStyle, useI18nContext } from "@hopper-b2b/i18n";
import {
  getParticipantCountFromAgeBandSelection,
  useMinutesToHoursAndMinutes,
} from "@tenant/activities";
import dayjs from "dayjs";
import { calculateEndTimeLabel } from "../utils/calculateEndTimeLabel";

export const useActivityDetailsPanel = (reservation: ActivityReservation) => {
  const { t, formatDateTime } = useI18nContext();

  const details = reservation.activityDetails;
  const selection = reservation.activitySelection;
  const durationMinutes = details?.duration ?? 0;
  const duration = useMinutesToHoursAndMinutes(durationMinutes);

  const startDate = dayjs(selection?.travelDate);
  const startTime = selection?.providerActivityStartTime;
  const formattedStartDate = formatDateTime(
    startDate.toDate(),
    DateTimeFormatStyle.ShortMonthDayShortWeekday
  );
  const startTimeLabel = t("activities.postBooking.localTimeLabel", {
    date: formattedStartDate,
    time: startTime,
  });

  const endTimeLabel = calculateEndTimeLabel({
    startDate,
    startTime,
    durationMinutes,
    t,
    formatDateTime,
    DateTimeFormatStyle,
  });

  const name = details.name ?? t("activities.postBooking.tripCardTitle");
  const image = details.coverImage;
  const rating = details.rating;
  const languageGuide = selection?.languageGuide?.languageDisplayName;
  const cancellationPolicy = reservation.cancellationPolicy?.cancellationPolicy;
  const voucherUrl = reservation.ticketInfo?.url;

  const participantCount = getParticipantCountFromAgeBandSelection(
    selection?.ageBandSelection
  );

  const travelerLabel = t("core-activities.checkout.confirmation.travelers", {
    count: participantCount,
  });

  return {
    name,
    duration,
    image,
    rating,
    cancellationPolicy,
    voucherUrl,
    languageGuide,
    startTimeLabel,
    endTimeLabel,
    travelerLabel,
  };
};
